export default __webpack_public_path__ + "static/media/The Necros of Dagon.3126568f.jpg";